export { default } from 'containers/Home'
